<template>
  <div class="mainContainer" v-if="pageState == 1">
    <div class="tabs">
      <div v-has="'pc_month_plan_manage'" @click="typeFun(2)" class="left" :class="{ active: planType === 2 }">月计划</div>
      <div v-has="'pc_year_plan_manage'" @click="typeFun(1)" class="right" :class="{ active: planType === 1 }">年计划</div>
    </div>
    <div class="nav">
      <div class="navContainer" style="width: 700px">
        <p>标题：</p>
        <el-input v-model="title" size="mini" placeholder="请输入标题" style="width: 160px" />
        <p style="margin-left: 10px">审核状态：</p>
        <el-select v-model="auditStatus" filterable size="mini" style="width:150px" placeholder="请选择审核状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
        <p style="margin-left: 10px">锁定状态：</p>
        <el-select v-model="lockingType" filterable size="mini" style="width:150px" placeholder="请选择锁定状态">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
<!--      <div class="navContainer" style="width: 260px" v-if="false">-->
<!--        <p>起始计划时间：</p>-->
<!--        <el-date-picker v-model="yearIpt" :type="planType === 1 ? 'year' : 'month'" size="mini" style="width: 160px" :value-format="planType === 1 ? 'yyyy' : 'yyyy-MM'" :placeholder="planType === 1 ? '请选择年计划时间' : '请选择月计划时间'" />-->
<!--      </div>-->
<!--      <div class="navContainer" style="width: 260px" v-if="false">-->
<!--        <p>结束计划时间：</p>-->
<!--        <el-date-picker v-model="yearIpt2" :type="planType === 1 ? 'year' : 'month'" size="mini" style="width: 160px" :value-format="planType === 1 ? 'yyyy' : 'yyyy-MM'" :placeholder="planType === 1 ? '请选择年计划时间' : '请选择月计划时间'" />-->
<!--      </div>-->
<!--      <div class="navContainer" v-if="false">-->
<!--        <p>状态：</p>-->
<!--        <el-select v-model="stateIpt" filterable size="mini" style="width: 150px" placeholder="请选择状态">-->
<!--          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />-->
<!--        </el-select>-->
<!--      </div>-->
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="mini" type="danger" @click="disableBtn">批量删除</el-button>

      </div>
    </div>
<!--    <el-row>-->
<!--      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">-->
<!--        <div style="display: flex; justify-content: flex-end">-->
<!--          <span>导出</span>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
    <div class="content">
      <div class="tableContainer">
        <el-table v-loading="tableLoad" :data="TableDatas" style="width: 100%" ref="registerTable"
                  border  :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }"
                  :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
                  @selection-change='selectionDataChange'
                  :row-style="rowStyle" >
          <el-table-column type='selection' align='center' width='50' />
          <el-table-column label="序号" align="center" type="index" width="50px" />
          <el-table-column prop="title" label="标题" align="center" />
          <el-table-column prop="auditStatus" label="审核状态" align="center" :formatter="getAuditStatus"/>
          <el-table-column prop="lockingType" label="锁定状态" align="center" :formatter="getLockingType"/>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" width="350" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
              <el-button size="mini" type="danger" @click="disableClick(scope.row.id)">删除</el-button>
              <el-button size="mini" type="primary" v-if="scope.row.auditStatus === 0 ||scope.row.auditStatus === 3" @click="sendClick(scope.row)">送审</el-button>
              <el-button size="mini" type="primary" v-if="scope.row.auditStatus === 1 ||scope.row.auditStatus === 2" @click="cancelClick(scope.row)">撤回</el-button>
              <div v-show="tableToggle" class="table-toggle">
                <!--                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>-->
                <el-button size="mini" class="yellow-bg" @click="updateClick(scope.row)">修改标题 </el-button>
                <el-button size="mini" type="primary" @click="historyClick(scope.row)">历史审核记录</el-button>
                <el-button size="mini" type="primary" @click="unlockClick(scope.row)">解锁</el-button>
              </div>
              <el-button size="mini" type="text" @click="tableToggle = !tableToggle">...
                <i :class="tableToggle ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="550px" center @close="dialogClose" :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="planData" label-width="95px" :rules="rules" ref="ruleForm">
          <el-form-item label="标题：" prop="title">
            <el-input v-model="planData.title" size="mini" placeholder="请输入标题" style="width: 160px" />
          </el-form-item>
<!--          <el-form-item label="计划类型：" prop="type">-->
<!--            <el-radio-group v-model="planData.type">-->
<!--              <el-radio :label="1">年计划</el-radio>-->
<!--              <el-radio :label="2">月计划</el-radio>-->
<!--            </el-radio-group>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="计划时间：" prop="time">-->
<!--            <el-date-picker v-model="planData.time" :type="planType === 1 ? 'year' : 'month'" size="mini" style="width: 160px" :value-format="planType === 1 ? 'yyyy' : 'yyyy-MM'" :placeholder="planType === 1 ? '请选择年计划时间' : '请选择月计划时间'" />-->
<!--            <hr color="#F0F0F2" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="托运品牌：" prop="brand">-->
<!--            <el-select v-model="planData.brand" filterable size="mini" style="width: 100%" placeholder="请选择托运品牌" value-key="id">-->
<!--              <el-option v-for="item in brandOption" :key="item.id" :label="item.brand" :value="item" />-->
<!--            </el-select>-->
<!--            <hr color="#F0F0F2" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="托运数量：" prop="num">-->
<!--            <el-input :style="'width:100%'" v-model="planData.num" placeholder="请输入托运数量" autocomplete="off" size="mini" />-->
<!--            <hr color="#F0F0F2" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="计划收入：" prop="income">-->
<!--            <el-input :style="'width:100%'" v-model="planData.income" placeholder="请输入计划收入" autocomplete="off" size="mini" />-->
<!--            <hr color="#F0F0F2" />-->
<!--          </el-form-item>-->
          <div class="btnContainer">
            <el-button class="searchBtn" :loading="addLoad" size="small" @click="addClick">确认</el-button>
            <el-button class="resetBtn" size="small" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :title="detailTitle" :visible.sync="detailDialogVisible" width="600px" center>
      <div class="detail">
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>审核信息</span>
          </div>
          <steps :step-data='stepData' :step-state='stepState' />
        </div>
      </div>
    </el-dialog>
  </div>
  <div v-else>
    <div class="btn">
      <el-button @click="typeYearFun('launchedName')" :class="launchedClass">下水小计</el-button>
      <el-button @click="typeYearFun('upstreamName')" :class="upstreamClass">上水小计</el-button>
    </div>
    <div >
      <year-total-plan-table-vue v-if="showYearTable" ref="yearRef" :tableName="tableName" :fieldName="fieldName" :rowData="selectedDatas"  @changePage="changePage"  />
    </div>
  </div>
  <!-- 测试1 YearTotalPlanTable -->
  <!-- 测试2 -->
</template>

<script>
import {
  addPlan,
  updatePlan,
  getPlanPageList,
  deletePlan,
  lockUnlock,
  detailPlan, resubmit, withdraw
} from '@/service/vehiclelog';
  import { formatDateTime } from '@/config/mUtils';
  import YearTotalPlanTableVue from '@/components/YearTotalPlanTable.vue';
import {update} from "@/service/basicfile";
import steps from '@/components/steps';

  export default {
    components: {
      YearTotalPlanTableVue,steps
    },

    data() {
      let validateNum = function (rule, value, callback) {
        if (Number(value) < 0) {
          callback(new Error('托运数量必须大于0'));
        }
        callback();
      };
      let validateIncome = function (rule, value, callback) {
        if (Number(value) < 0) {
          callback(new Error('计划收入必须大于0'));
        }
        callback();
      };
      return {
        tableToggle: false,
        showYearTable: true,
        pageState: 1,
        tableLoading: false,
        title: '',
        auditStatus: '',
        lockingType: '',
        planType: 0,
        yearIpt: '',
        yearIpt2: '',
        stateIpt: '',
        stateOption: [
          { value: '', label: '全部' },
          { value: '0', label: '已保存' },
          { value: '1', label: '提交审核' },
          { value: '2', label: '审核通过' },
          { value: '3', label: '未通过审核' },
        ],
        typeOption: [
          { value: '', label: '全部' },
          { value: '0', label: '未锁定' },
          { value: '1', label: '锁定' },
        ],
        tableLoad: false,
        TableDatas: [],
        selectedData: [],
        page: 1,
        size: 10,
        total: 0,
        dialogTitle: '',
        dialogVisible: false,
        addLoad: false,
        brandOption: [
          { id: '111', name: '品牌1', label: '品牌1' },
          { id: '222', name: '品牌2', label: '品牌2' },
          { id: '333', name: '品牌3', label: '品牌3' },
        ],
        planData: {
          title: '',
        },
        rules: {
          // time: [{ required: true, message: this.planType === 1 ? '请选择年计划时间' : '请选择月计划时间', trigger: 'blur' }],
          // brand: [{ required: true, message: '请选择托运品牌', trigger: 'change' }],
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
          // num: [
          //   { required: true, message: '请输入托运数量', trigger: 'blur' },
          //   { validator: validateNum, trigger: 'blur' },
          // ],
          // income: [
          //   { required: true, message: '请输入计划收入', trigger: 'blur' },
          //   { validator: validateIncome, trigger: 'blur' },
          // ],
        },
        detailDialogVisible: false,
        detailData: {},
        detailTitle: '',
        stepData: [],
        operationData: [],
        selectedDatas:{},
        tableName: 'launchedName',
        fieldName: 'launchedName',
        launchedClass: 'btn-launched',
        upstreamClass: 'btn-upstream',
        launchedActiveClass: 'btn-launched-active',
        upstreamActiveClass: 'btn-upstream-active',
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getStyle() {
        return val => {
          switch (val) {
            case 0:
              return 'color: rgba(249, 166, 6, 1)';
            case 1:
              return 'color: rgba(51, 84, 131, 100);';
            case -1:
              return 'color:#F56C6C;';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待审核';
            case 1:
              return '已审核';
            case -1:
              return '未通过';
          }
        };
      },
      getType() {
        return function (type) {
          switch (type) {
            case 1:
              return '年计划';
            case 2:
              return '月计划';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
    },
    mounted() {
      this._planPageList()
      this.launchedClass = this.launchedActiveClass;
    },
    methods: {
      update,
      changePage(type) {
        this.pageState = type;
      },
      typeYearFun(type){
        this.tableName = this.selectedDatas[type]
        this.fieldName = type
        this.showYearTable = false
        this.launchedClass = this.launchedActiveClass;
        this.upstreamClass = this.upstreamActiveClass;
        setTimeout(()=>{
          this.showYearTable = true
        })
        if (type === 'launchedName') {
          this.launchedClass = this.launchedActiveClass;
          this.upstreamClass = 'btn-upstream'
        } else if (type === 'upstreamName') {
          this.upstreamClass = this.upstreamActiveClass;
          this.launchedClass = 'btn-launched'
        }
      },
      getAuditStatus(r,c,cellValue){
        switch (cellValue){
          case 0:
            return '已保存'
          case 1:
            return '提交审核'
          case 2:
            return '审核通过'
          case 3:
            return '未通过审核'
        }
      },
      getLockingType(r,c,cellValue){
        switch (cellValue){
          case 0:
            return '未锁定'
          case 1:
            return '锁定'
        }
      },
      btnClick(type) {},
      selectionDataChange(selection) {
        this.selectedData = selection;
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      //查询
      searchBtn() {
        this.page = 1;
        this._planPageList();
      },
      async _planPageList() {
        this.tableLoad = true;
        const obj = {
          title: this.title,
          auditStatus: this.auditStatus,
          lockingType: this.lockingType,
          // startTime: this.yearIpt,
          // endTime: this.yearIpt2,
          // state: this.stateIpt,
          // type: this.planType,
          rows: this.size,
          page: this.page,
        };
        const res = await getPlanPageList(obj);
        this.tableLoad = false;
        if (res.status !== null) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      typeFun(val) {
        this.resetBtn();
        this.planType = val;
        this._planPageList();
      },
      resetBtn() {
        this.title = '';
        this.auditStatus = ''
        this.lockingType = ''
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._planPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._planPageList();
      },
      //新增
      async addBtn() {
        this.dialogTitle = '新增'
        this.dialogVisible = true;

        // this.dialogTitle = this.planType === 1 ? '添加年计划' : '添加月计划';
        // let res = await yearSelectBrandByAll();
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.brandOption = res.data;
      },
      //批量删除
      disableBtn(){
        if (this.selectedData.length > 0) {
          this.$confirm('确认删除当前选中数据？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.tableLoad = true;
            const ids = this.selectedData.map(item => item.id).join(',');
            const { status, message } = await deletePlan(ids);
            if (status !== 0) {
              this.$message.warning(message);
              this.tableLoad = false;
              return;
            }
            this.$message.success(message);
            this.$refs.registerTable.clearSelection();
            this.selectedData = [];
            await this._planPageList();
          });
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      //修改标题
      updateClick(row){
        this.planData.createBy = row.createBy
        this.planData.createTime = row.createTime
        this.planData.id = row.id
        this.planData.launchedName = row.launchedName
        this.planData.title = row.title
        this.planData.upstreamName = row.upstreamName
        this.dialogTitle = '修改标题'
        this.dialogVisible = true;
      },
      //历史记录
     async historyClick(row){
       this.detailDialogVisible = true
       this.detailTitle = '历史审核记录'
       let res = await detailPlan(row.id)
       if (res.status !== 0) return this.$message.error(res.message);
       // 审核信息
       this.stepData = [];
       if (res.data && res.data.length > 0) {
         res.data.forEach((item) => {
           let status = '',
             temp = {
               title: '',
               time: '',
               state: '',
               remark: '',
             },
             text = '取消审核';
           if (item.status == 1) {
             text = '发起';
           }
           if (item.status == 0) {
             text = '解锁';
           }
           if (item.status == 4) {
             text = '撤回';
           }
           if (item.status == 3) {
             status = 'failure', text = '拒绝';
             temp = {
               'title': (item.deptName || '') + ' ' + (item.auditorName || '') + ' ' + text,
               'time': (item.createTime || ''),
               'state': status,
               'remark': (item.opinion || ''),
             };
           } else if (item.status == 2) {
             status = 'success', text = '同意';
             temp = {
               'title': (item.deptName || '') + ' ' + (item.auditorName || '') + ' ' + text,
               'time': (item.createTime || ''),
               'state': status,
               'remark': (item.opinion || ''),
             };
           } else {
             temp = {
               'title': (item.auditorName || '') + ' ' + text,
               'time': (item.createTime || ''),
               'state': status,
               'remark': (item.opinion || ''),
             };
           }
           this.stepData.push(temp);
         });
       }
      },
      //解锁
      unlockClick(row){
        this.$confirm('确定要解锁当前计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const ids = []
            ids.push(row.id)
            const res = await lockUnlock({ids});
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._planPageList();
          })
          .catch(() => {});
      },
      //送审
      sendClick(row){
        this.$confirm('确定要送审当前计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await resubmit({
              id:row.id,
              auditStatus: 1
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._planPageList();
          })
          .catch(() => {});
      },
      //撤回
      cancelClick(row){
        this.$confirm('确定要撤回当前计划吗','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:'warning'
        })
          .then(async () => {
            const res = await withdraw({
              id:row.id
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._planPageList();
          })
          .catch(() => {});
      },
      //删除
      disableClick(id) {
        this.$confirm('确定要删除当前计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deletePlan(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._planPageList();
          })
          .catch(() => {});
      },
      //详情
      async detailClick(row) {
        this.pageState = 2;
        this.selectedDatas = row
        this.tableName = this.selectedDatas['launchedName']
        // this.detailDialogVisible = true;
        // this.detailTitle = this.planType === 1 ? '年计划详情' : '月计划详情';
        // const res = await planDetail(id);
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.operationData = res.data.operateRecordList;
        // this.detailData = res.data;
      },
      async changeClick(item) {
        this.pageState = 2;
        // this.planData = {
        //   ...item,
        //   time: item.planTime,
        //   num: item.consignCount,
        //   income: item.planIncome,
        //   brand: { id: item.brandId, name: item.brandName, label: item.brandName },
        // };
        // this.dialogVisible = true;
        // this.dialogTitle = this.planType === 1 ? '修改年计划' : '修改月计划';
        // let res = await yearSelectBrandByAll();
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.brandOption = res.data;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      addClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.addLoad = true;
            if(this.planData.id){
              const obj = {
                ...this.planData
              };
              const res = await updatePlan(obj)
              this.addLoad = false;
              if (res.status !== -1) return this.$message.error(res.message);
              else this.$message.success(res.message);
              await this._planPageList();
              this.dialogClose();
            }else {
              const obj = {
                title: this.planData.title
              };
              const res =  await addPlan(obj);
              this.addLoad = false;
              if (res.status !== -1) return this.$message.error(res.message);
              else this.$message.success(res.message);
              await this._planPageList();
              this.dialogClose();
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 0px 15px 0 25px;
    background-color: #fff !important;
    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }
    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 245px;
      margin-bottom: 20px;
      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }
      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .active {
        background: #48599e;
        color: #fff;
      }
    }
    .nav {
      width: 100%;
      // height:40px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;
        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }
      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;
        ::v-deep {
          .el-table .cell {
            padding: 0;
          }
          .el-table th {
            padding: 0;
          }
          .el-table td {
            padding: 0;
          }
          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span {
          font-size: 13px;
        }
      }
    }
    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;
      .baseInfo {
        display: flex;
        flex-direction: column;
        &Title {
          display: flex;
          align-items: flex-end;
          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          &Item {
            margin-bottom: 20px;
            .span1 {
              font-weight: 700;
            }
            span {
              font-size: 14px;
            }
            .specialOne {
              width: 50%;
            }
          }
          .specialItem {
            display: flex;
          }
        }
      }
      .operation {
        display: flex;
        flex-direction: column;
        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }
          .cell {
            font-size: 10px;
            padding: 0;
          }
        }
        &Title {
          display: flex;
          align-items: flex-end;
          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
    .depart {
      width: 100%;
      padding: 20px 10px;
      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }
        .el-input__inner {
          border: none;
        }
        .el-form-item__label {
          padding: 0;
        }
        .el-form-item__content {
          position: relative;
        }
      }
      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }
      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;
        button {
          margin: 0 15px;
        }
      }
    }
    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }
      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 9px;
      }
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 245px;
    margin-bottom: 20px;
    div {
      //background: #ccc;
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: #48599e;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599e;
      font-weight: 700;
      transition: all 0.3s;
    }
    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .right {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .active {
      background: #48599e;
      color: #fff;
    }
  }
  .btn-launched {
    //background-color: #f0f0f0; /* 初始颜色 */
    color: black; /* 初始文字颜色 */
  }
  .btn-launched-active {
    background-color: skyblue; /* 活动状态颜色 */
    color: black; /* 活动状态文字颜色 */
  }
  .btn-upstream {
    //background-color: #f0f0f0; /* 初始颜色 */
    color: black; /* 初始文字颜色 */
  }
  .btn-upstream-active {
    background-color: skyblue; /* 活动状态颜色 */
    color: black; /* 活动状态文字颜色 */
  }
</style>
